import React, { FC, useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  TextField,
  Pivot,
  PivotLinkSize,
  PivotItem,
  IPivotStyles,
  IStyleSet,
  Text,
  mergeStyleSets,
  MessageBar,
  MessageBarType,
  PivotLinkFormat,
  Dropdown,
  IDropdownOption,
  registerIcons,
} from "@fluentui/react";
import ApiSpinner from "../common/ApiSpinner";
import { LineHandling } from "../../models";
import { LineHandlingApi } from "../../api/lineHandlingApi";
import "./NominationList.css";
import * as LineHandlingStore from "../../store/LineHandlingStore";
import * as SofViewStore from "../../store/SofViewStore";
import * as SelectedTabStore from "../../store/SelectedTabDataStore";
import * as ProcessFlowConfigStore from "../../store/ProcessFlowConfigStore";
import * as GeneralStore from "../../store/GeneralStore";
import { State } from "../../store";
import LineHandlingListItem from "./LineHandlingListItem2";
import clsx from "clsx";
import { PersistentDataService } from "../../services/PersistentDataService";
import { pushNotification } from "../../api/pushNotification";
import { FontIcon } from "@fluentui/react/lib/Icon";
import LineHandlingListItem2 from "./LineHandlingListItem2";

type Props = SelectedTabStore.SelectedTabState &
  SofViewStore.SofViewState &
  GeneralStore.GeneralState &
  typeof LineHandlingStore.actionCreators &
  typeof ProcessFlowConfigStore.actionCreators &
  typeof SelectedTabStore.actionCreators &
  typeof SofViewStore.actionCreators &
  typeof GeneralStore.actionCreators;

const pageSize = 20;
const classes = mergeStyleSets({
  tab: {
    // borderBottom: "1px solid #E2E6E8",
  },
  mainDiv: {
    overflow: "hidden",
      height: "100%",
  },
  pivotItem: {
    display: "inline-block",
    marginLeft: "10px",
  },
  mainList: {
    overflowX: "hidden",
    overflowY: "scroll",
    maxHeight: "calc(100vh - 230px)",
    padding: "0",
    marginRight: "1px",
  },
  searcheBoxDiv: {
    position: "absolute",
    top: "5px",
    right: "5px",
    width: "25%",
  },
  dropDownDiv: {
    position: "absolute",
    top: "5px",
    right: "26%",
    width: "8%",
  },
  oval: {
    minwidth: "50px",
    minheight: "50px",
    background: "#4CAF50",
    borderRadius: "50%",
    fontSize: "small",
    padding: "1px 6px 2px 6px",
    color: "#FFF",
  },
});

registerIcons({
  icons: {
    "custom-search-svg": (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5 12.5C7.83123 12.4997 9.1241 12.0541 10.1728 11.234L13.4697 14.531L14.5303 13.4705L11.2333 10.1735C12.0538 9.12475 12.4997 7.83158 12.5 6.5C12.5 3.19175 9.80825 0.5 6.5 0.5C3.19175 0.5 0.5 3.19175 0.5 6.5C0.5 9.80825 3.19175 12.5 6.5 12.5ZM6.5 2C8.98175 2 11 4.01825 11 6.5C11 8.98175 8.98175 11 6.5 11C4.01825 11 2 8.98175 2 6.5C2 4.01825 4.01825 2 6.5 2Z"
          fill="#4C4C4C"
        />
      </svg>
    ),
  },
});

// const pivotStyles: Partial<IStyleSet<IPivotStyles>> = {
//   link: {
//     minWidth: "120px",
//     fontSize: "14px",
//     fontWeight: 400,
//     borderRadius: "1000px",
//     selectors: {
//       ":hover": {
//         backgroundColor: "var(--grey-050)",
//         color: "var(--grey-800)",
//       },
//       ":active": {
//         backgroundColor: "var(--grey-050)",
//         color: "var(--grey-800)",
//       },
//     },
//   },
//   linkIsSelected: {
//     minWidth: "150px",
//     backgroundColor: "var(--grey-050)",
//     borderRadius: "1000px",
//     color: "var(--grey-800)",
//     fontWeight: 700,
//     fontSize: "14px",
//     selectors: {
//       ":hover": {
//         backgroundColor: "var(--grey-050)",
//         color: "var(--grey-800)",
//       },
//       ":active": {
//         backgroundColor: "var(--grey-050)",
//         color: "var(--grey-800)",
//       },
//     },
//   },
// };

const NominationListPage: FC<Props> = (props: Props) => {
  const [lineHandlings, setLineHandlings] = useState<LineHandling[]>([]);
  const [nextPage, setNextPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isEndReached, setIsEndReached] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [keyword, setKeyword] = useState<string>();
  const [newExpected, setNewExpected] = useState<"0">();
  const [newTendered, setNewTendered] = useState<"0">();
  const [newArrived, setNewArrived] = useState<"0">();
  const [newDeparted, setNewDeparted] = useState<"0">();
  const [newApproved, setNewApproved] = useState<"0">();
  const [salesOrg, setSalesOrg] = useState<string>();

  const options: IDropdownOption[] = [
    { key: "ALL", text: "ALL" },
    { key: "PHL", text: "PHL" },
    { key: "USA", text: "USA" },
  ];

  const removeScrolling = () => {
    const main = document.getElementById("div-nomination-list");
    if (main) {
      main.removeEventListener("scroll", trackScrolling);
    }
  };

  const trackScrolling = async () => {
    const main = document.getElementById("main-scroll");
    if (main) {
      const isBottom =
        main.getBoundingClientRect().bottom <= window.innerHeight;
      if (isBottom) {
        removeScrolling();
        setNextPage((prev) => prev + 1);
      }
    }
  };

  const loadItemsAsync = async (pageNo: number, searchString: string) => {
    try {
      if (pageNo === 1) {
        setLineHandlings([]);
      }
      setErrorMessage(undefined);
      setIsLoading(true);

      const result = await LineHandlingApi.getLineHandlingListAsync(
        props.selectedTab,
        getSalesOrg(),
        pageNo,
        pageSize,
        searchString
      );

      setIsLoading(false);
      setLineHandlings(
        pageNo === 1 ? result.results : [...lineHandlings, ...result.results]
      );
      var newCount = JSON.parse(result.optionalProperties);
      setNewExpected(newCount.newExpectedCount);
      setNewTendered(newCount.newTenderedCount);
      setNewArrived(newCount.newArrivedCount);
      setNewDeparted(newCount.newDepartedCount);
      setNewApproved(newCount.newApprovedCount);

      const hasMorePages = Math.ceil(result.totalResults / pageSize) > pageNo;
      setIsEndReached(!hasMorePages);
      if (hasMorePages) {
        const wrappedElement = document.getElementById("div-nomination-list");
        if (wrappedElement)
          wrappedElement.addEventListener("scroll", trackScrolling);
      } else {
        removeScrolling();
      }
    } catch (err) {
      const offlineResult = await PersistentDataService.getOfflineLineHandling(
        props.selectedTab
      );
      setLineHandlings(offlineResult);
      setIsEndReached(true);
      setIsLoading(false);
    }
  };

  const searchAsync = async () => {
    if (keyword !== undefined && (keyword.length > 2 || keyword.length === 0)) {
      await loadItemsAsync(1, keyword);
    }
  };

  const getSalesOrg = () => {
    if (salesOrg) {
      return salesOrg;
    } else {
      return props.marineSalesOrg;
    }
  };

  const iconProps = { iconName: "custom-search-svg" };

  useEffect(() => {
    const timeoutId = setTimeout(() => searchAsync(), 1000);

    return () => clearTimeout(timeoutId);
  }, [keyword]);

  useEffect(() => {
    if (getSalesOrg()) {
      loadItemsAsync(nextPage, keyword === undefined ? "" : keyword);
    }
  }, [nextPage]);

  useEffect(() => {
    if (getSalesOrg()) {
      setNextPage(1);
      setLineHandlings([]);
      loadItemsAsync(nextPage, keyword === undefined ? "" : keyword);
    }
  }, [props.selectedTab, props.marineSalesOrg, salesOrg]);

  useEffect(() => {
    props.getAllConfigs();
    props.deleteActiveLineHandling();
    props.deleteActiveNomination();
    props.deleteActiveConfig();
    return removeScrolling;
  }, []);

  // useEffect(() => {
  //   props.setPageTitle("Marine Nominations");
  // }, []);

  useEffect(() => {
    pushNotification.connection.off("ActivityUpdated");

    pushNotification.connection.on("ActivityUpdated", (message) => {
      var result = message as LineHandling;
      var lineHandlingNo = result.lineHandlingNo.toUpperCase();
      var lineHandlingList = lineHandlings;
      var lineHandling = lineHandlingList.find(
        (l) => l.lineHandlingNo.toUpperCase() === lineHandlingNo
      );
      var cnt = 0;
      if (lineHandling !== undefined && cnt === 0) {
        lineHandlingList.forEach((lineHandlingItem) => {
          if (
            lineHandlingItem.lineHandlingNo.toUpperCase() === lineHandlingNo
          ) {
            lineHandlingItem.progress = result.progress;
            lineHandlingItem.nominations.forEach((nominationItem) => {
              var nomination = result.nominations.find(
                (n) =>
                  n.nominationNo.toUpperCase() ===
                  nominationItem.nominationNo.toUpperCase()
              );

              if (nomination !== undefined) {
                nominationItem.currentStep = nomination.currentStep;
                nominationItem.progress = nomination.progress;
                nominationItem.lastActivityDateString =
                  nomination.lastActivityDateString;
              }
            });
          }
        });

        cnt += 1;
        setLineHandlings([]);
        setLineHandlings(lineHandlingList);
      }
    });
  }, [lineHandlings]);

  return (
    <>
      <div className={classes.mainDiv}>
        <div
          className="ms-Grid"
          dir="ltr"
          style={{ backgroundColor: "white", margin: "12px", padding: "0px" }}
        >
          <div className="ms-Grid-row" style={{ padding: "10px 20px" }}>
            <div className="ms-Grid-col ms-md4">
              <div style={{ fontSize: 24, lineHeight: "48px" }}>
                Marine Nominations
              </div>
            </div>
            <div className="ms-Grid-col ms-md2"></div>
            <div
              className="ms-Grid-col ms-md6"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                columnGap: 16,
              }}
            >
              <div
                style={{
                  width: 120,
                  padding: "12px 16px",
                  textAlign: "center",
                  background: "#fff",
                  borderColor:
                    props.selectedTab === "Expected" ? "#262626" : "#fff",
                  borderWidth: 0.5,
                  borderRadius: 4,
                  border: props.selectedTab === "Expected" ?"1px solid #262626":"none",
                  cursor:
                    props.selectedTab === "Expected" ? "default" : "pointer",
                }}
                onClick={() => props.setSelectedTab("Expected","marine")}
              >
                Expected
              </div>
              <div
                style={{
                  width: 120,
                  padding: "12px 16px",
                  textAlign: "center",
                  background: "#fff",
                  borderColor:
                    props.selectedTab === "Tendered" ? "#262626" : "#fff",
                  borderWidth: 0.5,
                  borderRadius: 4,
                  border: props.selectedTab === "Tendered" ?"1px solid #262626":"none",
                  cursor:
                    props.selectedTab === "Tendered" ? "default" : "pointer",
                }}
                onClick={() => props.setSelectedTab("Tendered","marine")}
              >
                Tendered
              </div>
              <div
                style={{
                  width: 120,
                  padding: "12px 16px",
                  textAlign: "center",
                  background: "#fff",
                  borderColor:
                    props.selectedTab === "Arrived" ? "#262626" : "#fff",
                  borderWidth: 0.5,
                  borderRadius: 4,
                  border: props.selectedTab === "Arrived" ?"1px solid #262626":"none",
                  cursor:
                    props.selectedTab === "Arrived" ? "default" : "pointer",
                }}
                onClick={() => props.setSelectedTab("Arrived","marine")}
              >
                Arrived
              </div>
              <div
                style={{
                  width: 120,
                  padding: "12px 16px",
                  textAlign: "center",
                  background: "#fff",
                  borderColor:
                    props.selectedTab === "Departed" ? "#262626" : "#fff",
                  borderWidth: 0.5,
                  borderRadius: 4,
                  border: props.selectedTab === "Departed" ?"1px solid #262626":"none",
                  cursor:
                    props.selectedTab === "Departed" ? "default" : "pointer",
                }}
                onClick={() => props.setSelectedTab("Departed","marine")}
              >
                Departed
              </div>
              <div
                style={{
                  width: 120,
                  padding: "12px 16px",
                  textAlign: "center",
                  background:"#fff",
                  borderColor:
                    props.selectedTab === "Approved" ? "#262626" : "#fff",
                  borderWidth: 0.5,
                  borderRadius: 4,
                  border: props.selectedTab === "Approved" ?"1px solid #262626":"none",
                  cursor:
                    props.selectedTab === "Approved" ? "default" : "pointer",
                }}
                onClick={() => props.setSelectedTab("Approved","marine")}
              >
                Approved
              </div>
              {/*<Pivot*/}
              {/*  getTabId={(key: string, index: number) =>*/}
              {/*    `tab-${key.toLowerCase()}`*/}
              {/*  }*/}
              {/*  linkFormat={PivotLinkFormat.tabs}*/}
              {/*  styles={pivotStyles}*/}
              {/*  className={classes.tab}*/}
              {/*  linkSize={PivotLinkSize.large}*/}
              {/*  selectedKey={props.selectedTab}*/}
              {/*  onLinkClick={(item?: PivotItem | undefined) =>*/}
              {/*    item &&*/}
              {/*    item.props.headerText &&*/}
              {/*    props.setSelectedTab(item.props.headerText)*/}
              {/*  }*/}
              {/*>*/}
              {/*  <PivotItem*/}
              {/*    key="Expected"*/}
              {/*    itemKey="Expected"*/}
              {/*    headerText="Expected"*/}
              {/*    onRenderItemLink={() => (*/}
              {/*      <div style={{ width: "100%" }}>*/}
              {/*        <span>Expected</span>*/}
              {/*        {!isLoading &&*/}
              {/*          newExpected != "0" &&*/}
              {/*          newExpected !== undefined && (*/}
              {/*            <span className={classes.pivotItem}>*/}
              {/*              <span className={classes.oval}>{newExpected}</span>*/}
              {/*            </span>*/}
              {/*          )}*/}
              {/*      </div>*/}
              {/*    )}*/}
              {/*    headerButtonProps={{*/}
              {/*      disabled: isLoading,*/}
              {/*    }}*/}
              {/*  />*/}

              {/*  <PivotItem*/}
              {/*    key="Arrived"*/}
              {/*    itemKey="Arrived"*/}
              {/*    headerText="Arrived"*/}
              {/*    onRenderItemLink={() => (*/}
              {/*      <div style={{ width: "100%" }}>*/}
              {/*        <span>Arrived</span>*/}
              {/*        {!isLoading &&*/}
              {/*          newArrived != "0" &&*/}
              {/*          newArrived !== undefined && (*/}
              {/*            <span className={classes.pivotItem}>*/}
              {/*              <span className={classes.oval}>{newArrived}</span>*/}
              {/*            </span>*/}
              {/*          )}*/}
              {/*      </div>*/}
              {/*    )}*/}
              {/*    headerButtonProps={{*/}
              {/*      disabled: isLoading,*/}
              {/*    }}*/}
              {/*  />*/}

              {/*  <PivotItem*/}
              {/*    key={"Halted"}*/}
              {/*    itemKey={"Halted"}*/}
              {/*    headerText={"Halted"}*/}
              {/*    onRenderItemLink={() => (*/}
              {/*      <div style={{ width: "100%" }}>*/}
              {/*        <span>Halted</span>*/}
              {/*        {!isLoading &&*/}
              {/*          newHalted != "0" &&*/}
              {/*          newHalted !== undefined && (*/}
              {/*            <span className={classes.pivotItem}>*/}
              {/*              <span className={classes.oval}>{newHalted}</span>*/}
              {/*            </span>*/}
              {/*          )}*/}
              {/*      </div>*/}
              {/*    )}*/}
              {/*    headerButtonProps={{*/}
              {/*      disabled: isLoading,*/}
              {/*    }}*/}
              {/*  />*/}

              {/*  {modality === 2 && (*/}
              {/*    <PivotItem*/}
              {/*      key={"Repair"}*/}
              {/*      itemKey={"Repair"}*/}
              {/*      headerText={"Repair"}*/}
              {/*      onRenderItemLink={() => (*/}
              {/*        <div style={{ width: "100%" }}>*/}
              {/*          <span>Repair</span>*/}
              {/*          */}
              {/* {!isLoading && (*/}
              {/*
               */}
              {/*            <span className={classes.pivotItem}>*/}
              {/*
               */}
              {/*              <span className={classes.oval}></span>*/}
              {/*
               */}
              {/*            </span>*/}
              {/*
               */}
              {/*          )} */}
              {/*        </div>*/}
              {/*      )}*/}
              {/*      headerButtonProps={{*/}
              {/*        disabled: isLoading*/}
              {/*      }}*/}
              {/*    />*/}
              {/*  )}*/}

              {/*  {*/}
              {/*      modality === 1*/}
              {/*      &&*/}
              {/*      <PivotItem*/}
              {/*          key={modality === 1 ? "Rejected" : "Retain/Hold"}*/}
              {/*          itemKey={modality === 1 ? "Rejected" : "Retain/Hold"}*/}
              {/*          headerText={modality === 1 ? "Rejected" : "Retain/Hold"}*/}
              {/*          onRenderItemLink={() => (*/}
              {/*              <div style={{ width: "100%" }}>*/}
              {/*                  <span>{modality === 1 ? "Rejected" : "Retain/Hold"}</span>*/}
              {/*                  {!isLoading &&*/}
              {/*                      newRejected != "0" &&*/}
              {/*                      newRejected !== undefined && (*/}
              {/*                          <span className={classes.pivotItem}>*/}
              {/*                              <span className={classes.oval}>{newRejected}</span>*/}
              {/*                          </span>*/}
              {/*                      )}*/}
              {/*              </div>*/}
              {/*          )}*/}
              {/*          headerButtonProps={{*/}
              {/*              disabled: isLoading*/}
              {/*          }}*/}
              {/*      />*/}
              {/*  }*/}

              {/*  <PivotItem*/}
              {/*    key="Released"*/}
              {/*    itemKey="Released"*/}
              {/*    headerText="Released"*/}
              {/*    onRenderItemLink={() => (*/}
              {/*      <div style={{ width: "100%" }}>*/}
              {/*        <span>Released</span>*/}
              {/*        {!isLoading &&*/}
              {/*          newReleased != "0" &&*/}
              {/*          newReleased !== undefined && (*/}
              {/*            <span className={classes.pivotItem}>*/}
              {/*              <span className={classes.oval}>{newReleased}</span>*/}
              {/*            </span>*/}
              {/*          )}*/}
              {/*      </div>*/}
              {/*    )}*/}
              {/*    headerButtonProps={{*/}
              {/*      disabled: isLoading,*/}
              {/*    }}*/}
              {/*  />*/}
              {/*</Pivot>*/}
            </div>
          </div>
          <div className="ms-Grid-row" style={{ padding: "2px 20px" }}>
            <div className="ms-Grid-col ms-md6">
              <div style={{ maxWidth: 400 }}>
                <TextField
                  id="txt-search"
                  placeholder="Search by keyword"
                  iconProps={iconProps}
                  disabled={isLoading}
                  onChange={(e, newValue?: string | undefined) =>
                    setKeyword(newValue === undefined ? "" : newValue)
                  }
                  styles={{
                    fieldGroup: { height: "42px", border: "1px solid #D8DFE6" },
                    icon: {
                      lineHeight: "36px",
                      height: "40px",
                      width: "39px",
                      textAlign: "center",
                      background: "#EDEDED",
                      bottom: "0",
                      right: "0",
                      color: "#4C4C4C",
                    },
                  }}
                />
              </div>
            </div>
            {/* <div className="ms-Grid-col ms-md6">
                          <div style={{ maxWidth: 100, float: "right" } }>
                          <Dropdown
                              options={options}
                              defaultSelectedKey={getSalesOrg()}
                              disabled={props.marineSalesOrg !== "ALL" || isLoading}
                              onChange={(e, selectedOption) => {
                                  setSalesOrg(selectedOption!.text);
                              }}
                              className="searchDropdown"
                          />
                          </div>
                    </div> */}
          </div>
          {/*<div className="ms-Grid-row" style={{ padding: "20px" }}>*/}
          {/*  <div*/}
          {/*    className="ms-Grid-col ms-md12"*/}
          {/*    style={{ display: "flex", gap: 8 }}*/}
          {/*  >*/}
          {/*    */}
          {/*<Pivot*/}
          {/*    */}
          {/*  getTabId={(key: string, index: number) =>*/}
          {/*    */}
          {/*    `tab-${key.toLowerCase()}`*/}
          {/*    */}
          {/*  }*/}
          {/*    */}
          {/*  linkFormat={PivotLinkFormat.tabs}*/}
          {/*    */}
          {/*  styles={pivotStyles}*/}
          {/*    */}
          {/*  className={classes.tab}*/}
          {/*    */}
          {/*  linkSize={PivotLinkSize.large}*/}
          {/*    */}
          {/*  selectedKey={props.selectedTab}*/}
          {/*    */}
          {/*  onLinkClick={(item?: PivotItem | undefined) =>*/}
          {/*    */}
          {/*    item &&*/}
          {/*    */}
          {/*    item.props.headerText &&*/}
          {/*    */}
          {/*    props.setSelectedTab(item.props.headerText)*/}
          {/*    */}
          {/*  }*/}
          {/*    */}
          {/*>*/}
          {/*    */}
          {/*  <PivotItem*/}
          {/*    */}
          {/*    key="Expected"*/}
          {/*    */}
          {/*    itemKey="Expected"*/}
          {/*    */}
          {/*    headerText="Expected"*/}
          {/*    */}
          {/*    onRenderItemLink={() => (*/}
          {/*    */}
          {/*      <div style={{ width: "100%" }}>*/}
          {/*    */}
          {/*        <span>Expected</span>*/}
          {/*    */}
          {/*        {!isLoading &&*/}
          {/*    */}
          {/*          newExpected != "0" &&*/}
          {/*    */}
          {/*          newExpected !== undefined && (*/}
          {/*    */}
          {/*            <span className={classes.pivotItem}>*/}
          {/*    */}
          {/*              <span className={classes.oval}>{newExpected}</span>*/}
          {/*    */}
          {/*            </span>*/}
          {/*    */}
          {/*          )}*/}
          {/*    */}
          {/*      </div>*/}
          {/*    */}
          {/*    )}*/}
          {/*    */}
          {/*    headerButtonProps={{*/}
          {/*    */}
          {/*      disabled: isLoading,*/}
          {/*    */}
          {/*    }}*/}
          {/*    */}
          {/*  />*/}

          {/*    */}
          {/*  <PivotItem*/}
          {/*    */}
          {/*    key="Tendered"*/}
          {/*    */}
          {/*    itemKey="Tendered"*/}
          {/*    */}
          {/*    headerText="Tendered"*/}
          {/*    */}
          {/*    onRenderItemLink={() => (*/}
          {/*    */}
          {/*      <div style={{ width: "100%" }}>*/}
          {/*    */}
          {/*        <span>Tendered</span>*/}
          {/*    */}
          {/*        {!isLoading &&*/}
          {/*    */}
          {/*          newTendered != "0" &&*/}
          {/*    */}
          {/*          newTendered !== undefined && (*/}
          {/*    */}
          {/*            <span className={classes.pivotItem}>*/}
          {/*    */}
          {/*              <span className={classes.oval}>{newTendered}</span>*/}
          {/*    */}
          {/*            </span>*/}
          {/*    */}
          {/*          )}*/}
          {/*    */}
          {/*      </div>*/}
          {/*    */}
          {/*    )}*/}
          {/*    */}
          {/*    headerButtonProps={{*/}
          {/*    */}
          {/*      disabled: isLoading,*/}
          {/*    */}
          {/*    }}*/}
          {/*    */}
          {/*  />*/}

          {/*    */}
          {/*  <PivotItem*/}
          {/*    */}
          {/*    key="Arrived"*/}
          {/*    */}
          {/*    itemKey="Arrived"*/}
          {/*    */}
          {/*    headerText="Arrived"*/}
          {/*    */}
          {/*    onRenderItemLink={() => (*/}
          {/*    */}
          {/*      <div style={{ width: "100%" }}>*/}
          {/*    */}
          {/*        <span>Arrived</span>*/}
          {/*    */}
          {/*        {!isLoading &&*/}
          {/*    */}
          {/*          newArrived != "0" &&*/}
          {/*    */}
          {/*          newArrived !== undefined && (*/}
          {/*    */}
          {/*            <span className={classes.pivotItem}>*/}
          {/*    */}
          {/*              <span className={classes.oval}>{newArrived}</span>*/}
          {/*    */}
          {/*            </span>*/}
          {/*    */}
          {/*          )}*/}
          {/*    */}
          {/*      </div>*/}
          {/*    */}
          {/*    )}*/}
          {/*    */}
          {/*    headerButtonProps={{*/}
          {/*    */}
          {/*      disabled: isLoading,*/}
          {/*    */}
          {/*    }}*/}
          {/*    */}
          {/*  />*/}

          {/*    */}
          {/*  <PivotItem*/}
          {/*    */}
          {/*    key="Departed"*/}
          {/*    */}
          {/*    itemKey="Departed"*/}
          {/*    */}
          {/*    headerText="Departed"*/}
          {/*    */}
          {/*    onRenderItemLink={() => (*/}
          {/*    */}
          {/*      <div style={{ width: "100%" }}>*/}
          {/*    */}
          {/*        <span>Departed</span>*/}
          {/*    */}
          {/*        {!isLoading &&*/}
          {/*    */}
          {/*          newDeparted != "0" &&*/}
          {/*    */}
          {/*          newDeparted !== undefined && (*/}
          {/*    */}
          {/*            <span className={classes.pivotItem}>*/}
          {/*    */}
          {/*              <span className={classes.oval}>{newDeparted}</span>*/}
          {/*    */}
          {/*            </span>*/}
          {/*    */}
          {/*          )}*/}
          {/*    */}
          {/*      </div>*/}
          {/*    */}
          {/*    )}*/}
          {/*    */}
          {/*    headerButtonProps={{*/}
          {/*    */}
          {/*      disabled: isLoading,*/}
          {/*    */}
          {/*    }}*/}
          {/*    */}
          {/*  />*/}

          {/*    */}
          {/*  <PivotItem*/}
          {/*    */}
          {/*    key="Approved"*/}
          {/*    */}
          {/*    itemKey="Approved"*/}
          {/*    */}
          {/*    headerText="Approved"*/}
          {/*    */}
          {/*    onRenderItemLink={() => (*/}
          {/*    */}
          {/*      <div style={{ width: "100%" }}>*/}
          {/*    */}
          {/*        <span>Approved</span>*/}
          {/*    */}
          {/*        {!isLoading &&*/}
          {/*    */}
          {/*          newApproved != "0" &&*/}
          {/*    */}
          {/*          newApproved !== undefined && (*/}
          {/*    */}
          {/*            <span className={classes.pivotItem}>*/}
          {/*    */}
          {/*              <span className={classes.oval}>{newApproved}</span>*/}
          {/*    */}
          {/*            </span>*/}
          {/*    */}
          {/*          )}*/}
          {/*    */}
          {/*      </div>*/}
          {/*    */}
          {/*    )}*/}
          {/*    */}
          {/*    headerButtonProps={{*/}
          {/*    */}
          {/*      disabled: isLoading,*/}
          {/*    */}
          {/*    }}*/}
          {/*    */}
          {/*  />*/}
          {/*    */}
          {/*</Pivot>*/}
          {/*    <div className={classes.dropDownDiv}>*/}
          {/*      <Dropdown*/}
          {/*        options={options}*/}
          {/*        defaultSelectedKey={getSalesOrg()}*/}
          {/*        disabled={props.marineSalesOrg !== "ALL" || isLoading}*/}
          {/*        onChange={(e, selectedOption) => {*/}
          {/*          setSalesOrg(selectedOption!.text);*/}
          {/*        }}*/}
          {/*        className="searchDropdown"*/}
          {/*      />*/}
          {/*    </div>*/}

          {/*    <div className={classes.searcheBoxDiv}>*/}
          {/*      <TextField*/}
          {/*        id="txt-search"*/}
          {/*        placeholder="Search by keyword"*/}
          {/*        iconProps={iconProps}*/}
          {/*        disabled={isLoading}*/}
          {/*        onChange={(e, newValue?: string | undefined) =>*/}
          {/*          setKeyword(newValue === undefined ? "" : newValue)*/}
          {/*        }*/}
          {/*        styles={{*/}
          {/*          fieldGroup: {*/}
          {/*            height: "42px",*/}
          {/*            border: "1px solid var(--grey-200)",*/}
          {/*          },*/}
          {/*          icon: {*/}
          {/*            lineHeight: "36px",*/}
          {/*            height: "40px",*/}
          {/*            width: "39px",*/}
          {/*            textAlign: "center",*/}
          {/*            background: "#EDEDED",*/}
          {/*            bottom: "0",*/}
          {/*            right: "0",*/}
          {/*            color: "var(--grey-400)",*/}
          {/*          },*/}
          {/*        }}*/}
          {/*      />*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}
          {/*<div*/}
          {/*  className="ms-Grid-row"*/}
          {/*  style={{*/}
          {/*    padding: "20px 12px",*/}
          {/*    fontWeight: "bold",*/}
          {/*    borderBottom: "1px solid #E2E6E8",*/}
          {/*    borderTop: "1px solid #E2E6E8",*/}
          {/*    margin: 0,*/}
          {/*    color: "var(--grey-800)",*/}
          {/*    fontSize: 14,*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <div className="ms-Grid-col ms-md3">Vessel</div>*/}
          {/*  <div className="ms-Grid-col ms-md2">Line Handling #</div>*/}
          {/*  <div className="ms-Grid-col ms-md2">*/}
          {/*    {props.selectedTab === "Expected" && "ETA"}*/}
          {/*    {props.selectedTab === "Tendered" && "Tendered Date"}*/}
          {/*    {props.selectedTab === "Arrived" && "Arrival Date"}*/}
          {/*    {props.selectedTab === "Departed" && "Departure Date"}*/}
          {/*    {props.selectedTab === "Approved" && "Approval Date"}*/}
          {/*  </div>*/}
          {/*  <div className="ms-Grid-col ms-md1" style={{ paddingLeft: "20px" }}>*/}
          {/*    Nominations*/}
          {/*  </div>*/}
          {/*  <div className="ms-Grid-col ms-md1" style={{ paddingLeft: "40px" }}>*/}
          {/*    Progress*/}
          {/*  </div>*/}
          {/*  <div className="ms-Grid-col ms-md2"></div>*/}
          {/*</div>*/}
          <div
            id="div-nomination-list"
            className={clsx(classes.mainList, "custom-scroll")}
          >
            <div id="main-scroll" dir="ltr">
              {errorMessage && (
                <MessageBar messageBarType={MessageBarType.error}>
                  {errorMessage}{" "}
                  <a
                    onClick={() =>
                      loadItemsAsync(
                        nextPage,
                        keyword === undefined ? "" : keyword
                      )
                    }
                  >
                    Click here to retry.
                  </a>
                </MessageBar>
              )}

              {lineHandlings.map(
                (lineHandling: LineHandling, index: number) => (
                  <LineHandlingListItem
                          key={`line-handling-${index}`}
                          lineHandling={lineHandling}
                          onEtaUpdated={(lineHandling) => setLineHandlings([
                              ...lineHandlings.slice(0, index),
                              lineHandling,
                              ...lineHandlings.slice(index + 1),
                          ])} 
                  />
                )
              )}

              {isEndReached && !isLoading && (
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-md12">
                    <Text
                      variant="small"
                      block
                      style={{ textAlign: "center", color: "#c4c4c4" }}
                    >
                      - End of list -
                    </Text>
                  </div>
                </div>
              )}
              {isLoading && <ApiSpinner />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(
  (state: State) => (state: State) => ({
    ...state.selectedTab,
    ...state.general,
  }),

  {
    ...LineHandlingStore.actionCreators,
    ...ProcessFlowConfigStore.actionCreators,
    ...SofViewStore.actionCreators,
    ...SelectedTabStore.actionCreators,
    ...GeneralStore.actionCreators,
  }
)(NominationListPage as any);
